import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";
import { useSelector, useDispatch } from "react-redux";
import notificationAction from "../../redux/notification/action";

export const EmpLeave = () => {
  const employeeStore = useSelector((state) => state.employeeReducer);

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getEmployeeLeaves(
        employeeStore?.employee?.employee?._id
      );
      console.log(response);
      if (response?.success) {
        setData(response?.leaves || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (employeeStore?.employee?.employee?._id) {
      getData();
    }
  }, [employeeStore]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Leaves</h3>
            <Table data={data} />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreateLeaveModal
        show={show}
        handleClose={handleClose}
        getLeave={getData}
      />
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };
  const formatDateCreatedAt = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Name
                </th>
                <th scope="col" className="">
                  Email
                </th>
                <th scope="col" className="">
                  Start Date
                </th>
                <th scope="col" className="">
                  End Date
                </th>
                <th scope="col" className="">
                  Reason
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className="">
                  Created At
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.employee?.fullName}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.employee?.email}
                    </span>
                  </td>
                  <td>{item?.startDate ? formatDate(item?.startDate) : "-"}</td>
                  <td>{item?.endDate ? formatDate(item?.endDate) : "-"}</td>
                  <td>
                    <div
                      className="table-text-dark "
                      style={{ maxWidth: 200, minWidth: 130 }}
                    >
                      {item?.reason}
                    </div>
                  </td>
                  <td>
                    {item?.status == "Pending" ? (
                      <span class="badge bg-warning">{item?.status}</span>
                    ) : item?.status == "Approved" ? (
                      <span class="badge bg-success">{item?.status}</span>
                    ) : (
                      <span class="badge bg-danger">{item?.status}</span>
                    )}
                  </td>
                  <td>
                    {item?.createdAt
                      ? formatDateCreatedAt(item?.createdAt)
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const CreateLeaveModal = ({ show, handleClose, getLeave }) => {
  const [employees, setEmployees] = useState([]);
  const [data, setData] = useState({});
  const employeeStore = useSelector((state) => state.employeeReducer);
  const dispatch = useDispatch();

  const validator = () => {
    if (!employeeStore?.employee?.employee?._id) {
      return "Employee id is required";
    } else if (!data?.reason) {
      return "Reason is required";
    } else if (!data?.startDate) {
      return "Start Date is required";
    } else if (!data?.endDate) {
      return "End Date is required";
    }
    return "";
  };

  const handleSubmit = async () => {
    try {
      const validatorFields = validator();

      if (validatorFields) {
        notify.warning(validatorFields);
        return;
      }
      let payload = {
        employee: employeeStore?.employee?.employee?._id,
        reason: data?.reason,
        startDate: data?.startDate,
        endDate: data?.endDate,
      };
      const response = await api.addLeave(payload);
      console.log(response);
      if (response?.success) {
        getLeave();
        notify.success("Leave successfully added!");

        dispatch(
          notificationAction.setNotification({
            title: "New Leave Application",
            description: `${employeeStore?.employee?.employee?.fullName} has applied for leave`,
            details: {
              employeeName: employeeStore?.employee?.employee?.fullName,
              employeeEmail: employeeStore?.employee?.employee?.email,
              reason: data?.reason,
              startDate: new Date(data?.startDate).toLocaleDateString(),
              endDate: new Date(data?.endDate).toLocaleDateString(),
              leaveType: "Time Off",
              appliedAt: new Date().toLocaleString()
            },
            type: "info", 
          })
        );


        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Add Time Off</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Reason</label>
              <textarea
                rows={3}
                name="reason"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              ></textarea>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="datetime-local"
                name="startDate"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>End Date</label>
              <input
                type="datetime-local"
                name="endDate"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <div className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};
